<template>
  <div class="p-4 bg-white h-full box-border">
    <ul class="flex flex-wrap justify-between">
      <div class="flex flex-wrap">
        <!-- WJ-9710
          <li class="mr-3 mb-4" v-if="page != PAGE_TYPE.RECYCLED">
          <el-button size="small" type="primary" @click="onClickCreateWj">
            <span class="px-1">添加问卷</span>
          </el-button>
        </li> -->
        <!-- <li class="mr-6 mb-4 cursor-pointer text-blue-700" style="line-height:32px;" v-if="page!=PAGE_TYPE.RECYCLED">
          <i class="icon-chuangjianwenjian"></i>
        </li> -->
        <!-- 回收站排版更改 WJ-11621 -->
        <!-- <li class="mr-3 mb-4" v-if="page == PAGE_TYPE.RECYCLED">
          <el-button size="small" type="primary" @click="restore">
            <span class="px-1">还原</span>
          </el-button>
        </li>
        <li class="mr-3 mb-4" v-if="page == PAGE_TYPE.RECYCLED">
          <ClickDelete title="批量删除" @delFun="allDelete">
            <p slot="content">确定批量删除问卷数据</p>
            <el-button slot="delBtn" size="small" type="primary">批量删除</el-button>
          </ClickDelete>
        </li> -->
      </div>
      <div class="flex flex-wrap">
        <li class="mr-3 mb-4" style="width: 240px">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            :value-format="page == PAGE_TYPE.MCAF?'yyyy-MM-dd HH:mm:ss':'yyyy-MM-dd'"
            format="yyyy-MM-dd"
            range-separator="至"
            :start-placeholder="page == PAGE_TYPE.RECYCLED ? '移入时间' : '更新时间'"
            :end-placeholder="page == PAGE_TYPE.RECYCLED ? '移入时间' : '更新时间'"
            size="small"
            clearable
            @change="commonChange"
          ></el-date-picker>
        </li>
        <li class="mr-3 mb-4" style="width: 128px" v-if="page != PAGE_TYPE.MCAF">
          <el-select filterable v-model="formInline.sceneType" placeholder="项目类型" size="small" clearable @change="commonChange">
            <el-option v-for="item in projectListData" :key="item.sceneType" :label="item.label" :value="item.sceneType"></el-option>
            
          </el-select>
        </li>
        <li class="mr-3 mb-4" style="width: 128px" v-if="page != PAGE_TYPE.MCAF">
          <el-select v-model="formInline.publishStatus" placeholder="项目状态" size="small" clearable @change="commonChange">
            <el-option label="未发布" value="0"></el-option>
            <el-option label="回收中" value="2"></el-option>
            <el-option label="已关闭" value="1"></el-option>
            <el-option label="已下架" value="3"></el-option>
          </el-select>
        </li>
        <li class="mr-3 mb-4" style="width: 128px" v-if="page == PAGE_TYPE.MCAF">
          <el-select v-model="formInline.status" placeholder="项目状态" size="small" clearable @change="commonChange">
            <el-option label="未发布" :value="0"></el-option>
            <el-option label="回收中" :value="1"></el-option>
          </el-select>
        </li>
        <li class="mr-3 mb-4" style="width: 128px" v-if="page != PAGE_TYPE.MCAF">
          <el-select
            v-model="formInline.isStar"
            :disabled="page == PAGE_TYPE.COLLECTION"
            placeholder="收藏状态"
            size="small"
            clearable
            @change="commonChange"
          >
            <el-option label="未收藏" value="0"></el-option>
            <el-option label="已收藏" value="1"></el-option>
          </el-select>
        </li>
        <li class="mr-3 mb-4" v-if="page == PAGE_TYPE.RECYCLED" style="width: 128px">
          <el-select v-model="formInline.type" placeholder="协作类型" size="small" clearable @change="commonChange">
            <el-option label="共享给我的" value="2"></el-option>
            <el-option label="我创建的" value="1"></el-option>
          </el-select>
        </li>
        <li class="mr-3 mb-4" v-if="page != PAGE_TYPE.RECYCLED && page != PAGE_TYPE.MCAF" style="width: 128px">
          <!-- @blur="commonChange" -->
          <el-input
            v-model="formInline.complex"
            placeholder="创建者"
            size="small"
            clearable
            @clear="commonChange"
            @keyup.enter.native="toSearch"
          >
          </el-input>
        </li>
        <li class="mr-3 mb-4" :style="page == PAGE_TYPE.MCAF ? 'width: 128px' : 'width: 188px'">
          <!-- @blur="commonChange" -->
          <el-input
            v-model="formInline.id"
            :placeholder="page == PAGE_TYPE.MCAF ? '项目ID' : '项目标题/项目ID'"
            size="small"
            clearable
            @blur="commonChange"
            @clear="commonChange"
            @keyup.enter.native="toSearch"
          >
          </el-input>
        </li>
        <li class="mr-3 mb-4" style="width: 188px" v-if="page == PAGE_TYPE.MCAF">
          <!-- @blur="commonChange" -->
          <el-input
            v-model="formInline.title"
            placeholder="项目标题"
            size="small"
            clearable
            @blur="commonChange"
            @clear="commonChange"
            @keyup.enter.native="toSearch"
          >
          </el-input>
        </li>
        <li class="mb-4" v-if="page != PAGE_TYPE.RECYCLED" style="min-width: 140px">
          <el-button class="mr-0.5" size="small" type="primary" @click="toSearch">
            <span class="px-0.5">查询</span>
          </el-button>
          <el-button size="small" @click="onReset">
            <span class="px-0.5">重置</span>
          </el-button>
        </li>
      </div>
    </ul>
    <!-- 回收站显示 -->
    <!-- <div v-if="page == PAGE_TYPE.RECYCLED" class="block text-right mr-3">
      <el-tag size="medium"
        >当前表格已选择{{ selectedItems.length }}项
        <span class="cursor-pointer ml-1" @click="clearSelection">清 空</span>
      </el-tag>
    </div> -->
    <!-- 表格部分 -->
    <el-table
      ref="tabelContent"
      :data="tableData"
      v-loading="tableLoading"
      @sort-change="sortChange"
      size="medium"
      style="width: 100%"
      :height="`calc(100% - ${showDygcFooter ? '110px' : '80px'})`"
      @select="select"
      @select-all="selectAll"
      row-key="id"
      :header-row-style="headerRowStyle"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
    >
      <el-table-column v-if="page == PAGE_TYPE.RECYCLED" type="selection" reserve-selection width="60"> </el-table-column>
      <el-table-column
        v-for="(item, index) in tableOptionNew.column"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :min-width="item.minWidth"
        :width="item.width"
      >
        <template v-slot:default="scope">
          <!-- 标题 -->
          <div v-if="item.prop == 'title'">
            <div
              :style="{
                cursor: page != PAGE_TYPE.RECYCLED && page != PAGE_TYPE.MCAF ? 'pointer' : 'auto'
              }"
              :class="`name-title name_title_${scope.row.id}`"
              @mousedown="startLongPress(scope.row)"
              @mouseup="cancelLongPress(scope.row)"
            >
              <div v-truncate="scope.row.title"></div>
            </div>
            <!-- v-if="userInfo.username !== getUserName(scope.row)" -->
            <!-- v-if="page === PAGE_TYPE.COOPERATION" -->
            <!-- 换壳的 不显示 -->
            <div v-if="page != PAGE_TYPE.MCAF">
              <div
                style="font-size: 12px; color: rgba(0, 0, 0, 0.45)"
                v-truncate="getExtra(scope.row.extra, scope.row.internalShare)"
              ></div>
            </div>
          </div>
          <!-- 项目类型 -->
          <div v-else-if="item.prop == 'sceneTypeDesc'">
            <div v-if="page == PAGE_TYPE.MCAF">明察暗访</div>
            <div v-else>{{scope.row.sceneTypeDesc}}</div>
          </div>
          <!-- 收藏 -->
          <span v-else-if="item.prop == 'isStar'" class="cursor-pointer">
            <i
              v-if="scope.row.isStar"
              class="icon-woshoucangde text-medium-x"
              style="color: #f9ac30"
              @click="closeStart(scope.row)"
            ></i>
            <i
              v-else
              class="el-icon-star-off text-medium-x"
              style="color: #aaa"
              @click="page != PAGE_TYPE.RECYCLED ? addStart(scope.row) : ''"
            ></i>
          </span>
          <!-- 项目ID -->
          <span v-else-if="item.prop == 'id'" class="cursor-pointer" :class="'wjId_' + scope.row[item.prop]">
            <span @click="copySurveyId(scope.row[item.prop])">{{ scope.row[item.prop] }}</span>
          </span>
          <!-- 明察暗访项目状态 -->
          <div v-else-if="item.prop == 'status' && page == PAGE_TYPE.MCAF">
            <div v-if="scope.row.status==1">
              <Status pointColor="#00be6a" text="回收中" />
            </div>
            <div v-else>
              <Status pointColor="#e8a31b" text="未发布" />
            </div>
          </div>
          <!-- 问卷状态 -->
          <span v-else-if="item.prop == 'publishStatus'">
            <el-tooltip
              class="item"
              placement="bottom"
              :disabled="
                !(
                  scope.row.auditStatus === 0 ||
                  scope.row.auditStatus === 2 ||
                  scope.row.publishStatus == SURVEY_PUBLISH_STATUS.DOWN
                )
              "
            >
              <div slot="content">
                <div class="version-record">
                  <!-- 审核中 -->
                  <div class="time-line-item" v-if="scope.row.auditStatus === 0">
                    <div class="status">
                      <div class="version-and-status mb-2">
                        <span class="opacity-45 rounded-sm mr-1">{{ (scope.row.versionNum + 1).toFixed(1) }}版本</span>
                        <span class="text-yellow-theme"> 正在审核中 </span>
                      </div>

                      <div class="txt" style="height: 252px">
                        我们将在工作日 2 个小时内审核完毕问卷，您可以关注调研<br />工厂+服务号，实时获取审核结果<br />
                        <img :src="codeSrc" class="weixin" /><br />
                        如需加紧审核，请扫码联系客服<br />
                        <img :src="baseUrl + '/assets/img/code/Customer.Service.png'" class="weixin" /><br />
                      </div>
                      <div class="clear-both"></div>
                    </div>
                  </div>

                  <!-- 已下架 -->
                  <div class="time-line-item" v-if="scope.row.publishStatus == SURVEY_PUBLISH_STATUS.DOWN">
                    <div class="status">
                      <div class="version-and-status mb-2">
                        <span class="text-danger">问卷已下架</span>
                      </div>
                      <div class="txt">
                        下架原因：{{ lastReleaseVersion.underReason }}<br />如有疑问，请咨询客服<br />
                        <img :src="baseUrl + '/assets/img/code/Customer.Service.png'" class="weixin" />
                      </div>
                      <div class="clear-both"></div>
                    </div>
                  </div>

                  <!-- 审核拒绝 -->
                  <div class="time-line-item" v-if="scope.row.auditStatus === 2">
                    <div class="status">
                      <div class="version-and-status mb-2">
                        <span class="opacity-45 rounded-sm mr-1">{{ (scope.row.versionNum + 1).toFixed(1) }}版本</span>
                        <span class="text-danger">审核拒绝</span>
                      </div>
                      <div class="txt">
                        拒绝原因：{{ lastDraftVersion.sentisiveReason
                        }}<br />您可按要求修改后，重新发起审批。如有疑问，请咨询客服<br />
                        <img :src="baseUrl + '/assets/img/code/Customer.Service.png'" class="weixin" />
                      </div>
                      <div class="clear-both"></div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="scope.row.publishStatus == SURVEY_PUBLISH_STATUS.UNPUBLISHED">
                <!-- <span style="color: #e8a31b">未发布</span> -->
                <div @mouseover="getVersionAllSimple(scope.row.id)">
                  <Status pointColor="#e8a31b" text="未发布" /><span
                    class="ml-1"
                    v-if="scope.row.auditStatus === 0 || scope.row.auditStatus === 2"
                  >
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1 mr-6 text-medium"></i
                  ></span>
                </div>
              </template>
              <template v-if="scope.row.publishStatus == SURVEY_PUBLISH_STATUS.CLOSED">
                <!-- <span style="color: #6c748a">已关闭</span> -->
                <div @mouseover="getVersionAllSimple(scope.row.id)">
                  <Status pointColor="#6c748a" text="已关闭" /><span
                    class="ml-1"
                    v-if="scope.row.auditStatus === 0 || scope.row.auditStatus === 2"
                  >
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1 mr-6 text-medium"></i
                  ></span>
                </div>
              </template>
              <template v-if="scope.row.publishStatus == SURVEY_PUBLISH_STATUS.RECYCLING">
                <!-- <span style="color: #00be6a">回收中</span> -->
                <div @mouseover="getVersionAllSimple(scope.row.id)">
                  <Status pointColor="#00be6a" text="回收中" /><span
                    class="ml-1"
                    v-if="scope.row.auditStatus === 0 || scope.row.auditStatus === 2"
                  >
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1 mr-6 text-medium"></i
                  ></span>
                </div>
              </template>
              <template v-if="scope.row.publishStatus == SURVEY_PUBLISH_STATUS.DOWN">
                <div @mouseover="getVersionAllSimple(scope.row.id)">
                  <Status pointColor="#6c748a" text="已下架" /><span
                    class="ml-1"
                    v-if="scope.row.auditStatus === 0 || scope.row.auditStatus === 2"
                  >
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1 mr-6 text-medium"></i
                  ></span>
                  <span class="ml-1" v-else>
                    <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer ml-1 mr-6 text-medium"></i
                  ></span>
                </div>
              </template>
            </el-tooltip>
          </span>
          <span v-else-if="item.prop == 'createTime' || 'updateTime'">
            {{ scope.row[item.prop] | formatDate }}
          </span>
          <div v-else>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <!-- v-if="page != PAGE_TYPE.RECYCLED" -->
      <el-table-column prop="opt" fixed="right" label="操作" width="200">
        <template v-slot:default="scope">
          <div class="mr-4 inline-block">
            <!-- 编辑 -->
            <el-button
              class="mr-2"
              v-if="
                page != PAGE_TYPE.RECYCLED && page != PAGE_TYPE.MCAF &&
                (scope.row.shareWjAccess === null || scope.row.shareWjAccess.find(it => it.key === 'isSeeEdit').value)
              "
              type="text"
              @click="editMethod(scope.row)"
              >编辑</el-button
            >
            <!-- 明察暗访-编辑/管理 -->
            <el-button
              v-if="page == PAGE_TYPE.MCAF"
              type="text"
              class="mr-2"
              @click="handleMcaf(scope.row)"
            >管理</el-button>
            <!-- 发布/关闭/开启 -->
            <el-popover
              :title="popoverTitle(page == PAGE_TYPE.MCAF?scope.row.status:scope.row.publishStatus)"
              placement="top"
              width="260"
              :ref="`popover-${scope.$index}`"
              :visible.sync="openCloseVisible"
            >
              <div class="closeContent leading-22 mb-2" v-if="scope.row.publishStatus === SURVEY_PUBLISH_STATUS.RECYCLING">
                问卷关闭后，将停止回收数据（包括网络调查、面对面访问、CATI 云电话调查、委托代理等），<span class="content-color"
                  >你还要继续吗？</span
                >
              </div>
              <div v-if="scope.row.publishStatus === SURVEY_PUBLISH_STATUS.CLOSED" class="overflow-hidden mb-2">
                <span class="float-left">
                  <i class="el-icon-warning text-yellow-theme text-20"></i>
                </span>
                <span class="float-left ml-2">是否开启问卷</span>
              </div>
              <div v-if="scope.row.publishStatus === SURVEY_PUBLISH_STATUS.UNPUBLISHED" class="overflow-hidden mt-2 mb-2">
                <div class="float-left">
                  <i class="el-icon-warning text-yellow-theme text-20"></i>
                </div>
                <div class="float-left ml-2" style="width: 222px">确认发布问卷《{{ scope.row.title }}》吗？</div>
              </div>
              <div v-if="page == PAGE_TYPE.MCAF && scope.row.status === 0" class="overflow-hidden mb-2">
                <span class="float-left">
                  <i class="el-icon-warning text-yellow-theme text-20"></i>
                </span>
                <span class="float-left ml-2">是否开启明察暗访</span>
              </div>
              <div class="closeContent leading-22 mb-2" v-if="page == PAGE_TYPE.MCAF && scope.row.status === 1" >明察暗访关闭后，将停止上报案件<span class="content-color">，你还要继续吗？</span></div>
              <template
                v-if="
                  page != PAGE_TYPE.RECYCLED && page != PAGE_TYPE.MCAF &&
                  (scope.row.shareWjAccess === null || scope.row.shareWjAccess.find(it => it.key === 'isNetworkAgent').value)
                "
              >
                <el-button
                  slot="reference"
                  v-if="
                    scope.row.publishStatus === SURVEY_PUBLISH_STATUS.UNPUBLISHED ||
                    scope.row.publishStatus === SURVEY_PUBLISH_STATUS.CLOSED ||
                    scope.row.publishStatus === SURVEY_PUBLISH_STATUS.RECYCLING
                  "
                  type="text"
                  class="mr-2"
                >
                  {{ surveyStatusTextFun(scope.row.publishStatus) }}
                </el-button>
              </template>
              <template v-if="page == PAGE_TYPE.MCAF">
                <el-button
                  slot="reference"
                  type="text"
                  class="mr-2"
                >
                  {{ scope.row.status?'关闭':'开启' }}
                </el-button>
              </template>
              <div class="text-right m-0">
                <el-button size="mini" plain @click="closePop(scope)">取消</el-button>
                <el-button :type="scope.row.publishStatus === SURVEY_PUBLISH_STATUS.RECYCLING || scope.row.status===1? 'danger' : 'primary'" size="mini" @click="openCloseMethod(scope.row, scope)">{{
                  scope.row.publishStatus === SURVEY_PUBLISH_STATUS.RECYCLING || scope.row.status===1 ? '关闭' : '确定'
                }}</el-button>
              </div>
            </el-popover>
            <!-- 分析下载 2022-12-26改名为 数据 -->
            <el-button
              v-if="
                page != PAGE_TYPE.RECYCLED && page != PAGE_TYPE.MCAF &&
                (scope.row.shareWjAccess === null || scope.row.shareWjAccess.find(it => it.key === 'isExamineControl').value)
              "
              type="text"
              @click="recycleList(scope.row)"
              >数据</el-button
            >
            <ClickDelete title="温馨提示" @delFun="removeList(scope.row)" v-if="page === PAGE_TYPE.RECYCLED">
              <p slot="content">确定删除问卷数据</p>
              <span slot="delBtn" class="text-sm cursor-pointer text-theme">删除</span>
            </ClickDelete>
            <ClickDelete title="温馨提示" @delFun="deleteMcaf(scope.row)" v-if="page === PAGE_TYPE.MCAF">
              <p slot="content">确定删除明察暗访数据</p>
              <span slot="delBtn" class="text-sm cursor-pointer text-theme">删除</span>
            </ClickDelete>
            <!-- <el-button v-if="page === PAGE_TYPE.RECYCLED" type="text" @click="removeList(scope.row)">删除</el-button> -->
          </div>
          <!-- 展开组 -->
          <el-dropdown v-if="page != PAGE_TYPE.RECYCLED && page != PAGE_TYPE.MCAF" trigger="click" @command="onChangeCommand($event, scope)">
            <span class="el-dropdown-link cursor-pointer">
              <i class="el-icon-more el-icon--right" style="color: #909090"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="font-size: 14px" class="dropdown-menu">
              <el-dropdown-item command="preMethod" style="font-size: 14px">预览</el-dropdown-item>
              <el-dropdown-item command="shareQuestionnaire" v-if="scope.row.canShare" style="font-size: 14px"
                >分享协作</el-dropdown-item
              >
              <el-dropdown-item
                v-if="
                  page != PAGE_TYPE.RECYCLED &&
                  (scope.row.shareWjAccess === null || scope.row.shareWjAccess.find(it => it.key === 'isSeeEdit').value)
                "
              >
                <el-dropdown @command="onClickCopy($event, scope.row.id)">
                  <div class="el-dropdown-link flex justify-between items-center text-sm" style="width: 85px">
                    复制<i class="el-icon-arrow-right"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1" style="font-size: 14px">仅复制问题</el-dropdown-item>
                    <el-dropdown-item command="2" style="font-size: 14px">复制问题+逻辑控制</el-dropdown-item>
                    <el-dropdown-item command="3" style="font-size: 14px">复制问题+逻辑控制+网调配额</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-dropdown-item>
              <!-- <el-dropdown-item>
                <el-dropdown @command="onClickMove($event, scope.row.id)">
                  <span class="el-dropdown-link">移动至<i class="el-icon-arrow-right"></i></span>
                  <el-dropdown-menu slot="dropdown"> -->
              <!-- 不显示 全部 item.id !== ''-->
              <!-- <div v-for="(item,index) in surveyGroups" :key="index">
                      <el-dropdown-item
                        :command="item.id"
                        v-if="isShowMoveMenu(item, scope.row) && item.id !== ''"
                      >{{ item.groupName }}
                      </el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-dropdown-item> -->
              <ClickDelete title="问卷删除" @delFun="delMethod(scope.row)" delClass="delClass" class="del-survey block">
                <p slot="content">问卷《{{ scope.row.title }}》删除后将被移入回收站，可到回收站还原。</p>
                <el-dropdown-item
                  v-if="
                    ( scope.row.publishStatus === SURVEY_PUBLISH_STATUS.UNPUBLISHED ||
                    scope.row.publishStatus === SURVEY_PUBLISH_STATUS.CLOSED ) && 
                    scope.row.internalShare === null
                  "
                  style="padding-left: 15px; padding-right: 0" slot="delBtn">
                    <span class="text-sm inline-block">删除</span>
                </el-dropdown-item>
              </ClickDelete>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <template slot="empty">
        <template v-if="!page">
          <div>还没有项目，点击【添加项目】创建。</div>
          <el-button class="relative z-50" size="small" type="primary" @click="onClickCreateWj">添加项目</el-button>
        </template>
        <!-- 新版问卷没有‘回收中’侧边导航 -->
        <!-- <template v-else-if="status === '4'">
          <div>去“全部”列表，发布问卷。</div>
          <el-button class="relative z-50" size="small" type="primary" @click="toAllList">去"全部"列表</el-button>
        </template> -->
        <template v-else-if="page && page == PAGE_TYPE.COLLECTION">
          <div>去“全部”列表，点击问卷列表中<i style="font-size: 18px" class="el-icon-star-off"></i>添加。</div>
          <el-button class="relative z-50" size="small" type="primary" @click="toAllList">去"全部"列表</el-button>
        </template>
        <template v-else>
          <el-empty></el-empty>
        </template>
      </template>
    </el-table>
    <!-- 网站协议文案提示 -->
    <DygcFooter class="my-2" v-custom:home="'out_D19_1'" />
    <div class="w-full flex items-center justify-between" :class="showDygcFooter ? '' : 'pt-2'">
      <div :class="{'flex-1': true}" style="width: 680px;">
        <div class="mr-3 ml-3.5 inline-block" v-if="page == PAGE_TYPE.RECYCLED">
          <el-checkbox
            :indeterminate="!isAll && !!selectedItems.length && !!tableData.length"
            :value="isAll && !!tableData.length"
            @input="changeTableSelect"
          >
            <span class="ml-1 text-black text-opacity-65"
              >已选择
              <span class="text-theme">
                {{ isAll ? pagination.total : selectedItems.length }}
              </span>
              项</span
            >
          </el-checkbox>
          <el-checkbox
            :indeterminate="!isAll && !!selectedItems.length && !!tableData.length"
            :value="isAll && !!tableData.length"
            @input="onCheckedChange"
          >
            <span class="text-black text-opacity-65">选择全部</span>
          </el-checkbox>
        </div>
        <el-button v-if="page == PAGE_TYPE.RECYCLED" size="small" class="mr-2" type="primary" :disabled="!selectedItems.length" @click="restore">
          <span class="px-1">批量还原</span>
        </el-button>
        <ClickDelete v-if="page == PAGE_TYPE.RECYCLED" :disabled="!selectedItems.length" title="批量删除" @delFun="allDelete">
          <p slot="content">确定批量删除问卷数据</p>
          <el-button slot="delBtn" size="small" type="primary" :disabled="!selectedItems.length" class="ml-0.5" plain>批量删除</el-button>
        </ClickDelete>
      </div>
      <el-pagination
        class="bg-white"
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pagination.current"
        :page-size="pagination.size"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <!-- 旧分享协作 <el-dialog
      class="mainQSDialog"
      title="共享问卷"
      :visible.sync="transferVisible"
      width="840px"
      destroy-on-close
      @close="closeShareDialog"
    >
      <el-radio v-model="shareRadio" label="1" border style="margin-bottom: 10px; position: relative; left: "
        >从我的企业员工中选择</el-radio
      >
      <el-transfer
        style="text-align: left"
        v-model="sharedPerson"
        filterable
        :titles="['选择共享人', '已添加共享人']"
        filter-placeholder="请输入ID/手机号/姓名"
        :data="allSharePerson"
      >
      </el-transfer>
      <div
        style="border-bottom: 1px solid #dcdfe6; width: 800px; margin-top: 20px; margin-bottom: 15px; margin-left: -20px"
      ></div>
      <el-row type="flex" justify="center" :gutter="20" style="marigin: -10px 0">
        <el-col style="text-align: right"
          ><el-button
            style="width: 100px"
            type="primary"
            @click="confirmShares"
            :disabled="isEqual(sortby(sharedPersonBak), sortby(sharedPerson))"
            ><span class="text-medium">确定</span></el-button
          ></el-col
        >
        <el-col style="text-align: left"
          ><el-button @click="cancelShares" style="width: 100px"><span class="text-medium">取消</span></el-button></el-col
        >
      </el-row>
    </el-dialog> -->
    <el-dialog :visible.sync="closeVisible" class="message-dialog" title="关闭问卷" width="454px">
      <div class="closeContent leading-22">
        问卷关闭后，将停止回收数据（包括网络调查、面对面访问、CATI 云电话调查、委托代理等），<span class="content-color"
          >你还要继续吗？</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="normal-button" @click="closeVisible = false"
          ><span class="text-medium">取消</span></el-button
        >
        <el-button size="small" class="normal-button" type="primary" @click="sureClose"
          ><span class="text-medium">关闭</span></el-button
        >
      </span>
    </el-dialog>
    <sensitiveDialog :sensitiveShow="sensitiveShow" :sensitiveData="sensitiveData" @onCloseDialog="sensitiveShow = false" />
    <coord-manage-dialog :scene="scene" :visible.sync="showCoordManage" :question-id="questionId" :active-card="activeCard" />
    <share-coord-dialog :scene="scene" :visible.sync="showCoordShare" :question-id="questionId" />
  </div>
</template>

<script>
import wj_list from './wj_list.js'
export default {
  mixins: [wj_list]
  // 不要加其他内容，都去mixins里改动
}
</script>

<style>
.delClass {
  transform: translateY(-120px);
}
</style>
<style scoped lang="scss">
::v-deep .el-timeline-item__timestamp {
  float: left;
  margin-left: -404px;
}

.txt {
  @apply float-left mt-2 bg-card-bg-gray rounded-sm opacity-85 font-normal font-medium leading-5;
  width: 371px;
  padding: 8px 21px 8px 12px;
}
.weixin {
  width: 88px;
  height: 88px;
}
.version-record {
  width: 488px;
  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;

    @apply text-large font-MEDIUM font-medium text-theme-black-850;
  }

  .time-line {
    margin-top: 10px;
    padding: 10px 0;
    height: 500px;
    overflow: auto;
  }
}
.el-date-editor {
  width: 100% !important;
  ::v-deep .el-range-separator {
    width: auto;
  }
}
/* ::v-deep .mainQSDialog .el-dialog__body {
  border-top: 1px solid #dcdfe6;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 15px;
} */
/* ::v-deep .el-transfer-panel {
  width: 310px !important;
} */
.closeContent {
  color: #f04134;
  .content-color {
    color: #999999;
  }
}
::v-deep.el-table {
  .el-table__cell {
    height: 61px;
  }

  .el-table__header {
    .el-table__cell {
      height: 45px;
    }
  }
}
.name-title {
  height: 23px;
  // width: 200px;
  overflow: hidden;
  // word-break: break-all;
  // text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
::v-deep .el-loading-mask {
  top: 45px !important;
}
::v-deep .el-table__empty-block {
  align-items: start !important;
  .el-table__empty-text {
    margin-top: 22px;
  }
}
.dropdown-menu {
  ::v-deep .el-popover__reference-wrapper {
    @apply block;
    .el-popover__reference {
      @apply block;
    }
  }
}
</style>
